import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Drawer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { SidebarBSSPlatformTools, visibleTools } from '@tecma/ui';
import getToolLink from '../../utils/getToolLink';
const useStyles = makeStyles({
  root: {
    '& .tecma-SidebarBSSPlatformTools': {
      paddingTop: '85px',
      '& .sidebarBSSPlatformTools-header': {
        '& > .tecma-button': {
          color: '#6bc1b4'
        }
      },
      '& .tecma-card:not(.selected)': {
        cursor: 'pointer'
      },
      '& .sidebarBSSPlatformTools-redirect-button': {
        '& svg, path': {
          fill: '#6bc1b4'
        }
      },
      '& .sidebarBSSPlatformTools-toolBox.selected': {
        outlineColor: '#6bc1b4'
      }
    }
  }
});
const ToolsRedirector = observer(({
  products = [],
  enabledTools = [],
  loggedUser
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const handleToggle = () => {
    setShowMenu(prevShowMenu => !prevShowMenu);
  };
  const classes = useStyles();
  return products && products.length > 0 && enabledTools && enabledTools.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "desksidebar-tools-redirector",
    style: {
      // display: 'grid',
      display: 'none',
      placeContent: 'center',
      marginLeft: '36px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon large app-menu",
    onClick: handleToggle,
    style: {
      cursor: 'pointer'
    }
  })), /*#__PURE__*/React.createElement(Drawer, {
    anchor: 'left',
    open: showMenu,
    onClose: handleToggle,
    classes: {
      root: classes.root
    }
  }, /*#__PURE__*/React.createElement(SidebarBSSPlatformTools, {
    tools: visibleTools(products, enabledTools, loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.role, 'Emotions'),
    currentTool: "Emotions",
    imagesBaseUrl: `${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o"}/global/img/tools`,
    labels: {
      bssPlatform: 'BSS Platform',
      title: 'Passa a '
    },
    onCardClick: (toolName, currentTool, toolUrl) => {
      if (toolName !== currentTool) {
        window.location.href = toolUrl;
        return null;
      }
    },
    bssPlatformLink: getToolLink(enabledTools, 'businessplatform'),
    onLinkClick: link => {
      window.location.href = link;
      return null;
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null);
});
export default ToolsRedirector;